import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

/**
 * Header — minimal editorial nav with a scroll-to-quiz CTA.
 */
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 30);
      setHidden(y > lastY && y > 200);
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    const t = setTimeout(() => setEntered(true), 200);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
    };
  }, []);

  const scrollToQuiz = () => {
    const el = document.getElementById("quiz");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.header
          data-testid="site-header"
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: entered ? 0 : -80, opacity: entered ? 1 : 0 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.9, ease }}
          className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-500 ${
            scrolled ? "bg-obsidian/85 backdrop-blur-md border-b border-cream/10" : "bg-transparent"
          }`}
        >
          <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
            <a href="#top" data-testid="brand-link" className="flex items-baseline gap-2">
              <span className="font-serif text-2xl italic font-light text-cream tracking-tight">BB</span>
              <span className="font-sans text-xs uppercase tracking-[0.35em] text-cream/70">fit</span>
            </a>

            <nav className="hidden md:flex items-center gap-10 text-[0.72rem] uppercase tracking-[0.28em] text-cream/70 font-light">
              <a href="#metodo" data-testid="nav-metodo" className="nav-link">Metodo</a>
              <a href="#manifesto" data-testid="nav-manifesto" className="nav-link">Manifesto</a>
              <a href="#studio" data-testid="nav-studio" className="nav-link">Studio</a>
              <a href="#quiz" data-testid="nav-quiz" className="nav-link">Consulenza</a>
            </nav>

            <button
              type="button"
              onClick={scrollToQuiz}
              data-testid="header-cta"
              className="group flex items-center gap-3 border border-cream/25 hover:border-gold px-5 py-3 text-[0.7rem] uppercase tracking-[0.24em] text-cream hover:text-gold transition-colors duration-500"
            >
              <span>Inizia</span>
              <span aria-hidden className="inline-block w-8 h-px bg-cream/40 group-hover:bg-gold transition-colors duration-500" />
            </button>
          </div>
        </motion.header>
      )}
    </AnimatePresence>
  );
}
